<app-blogs [type]="type" />
